<section
  class="flex h-full flex-col rounded-lg border border-gray-200 bg-white p-3"
  [attr.aria-label]="title()">
  <div class="flex items-center gap-x-2">
    <mat-icon
      [svgIcon]="svgIcon()"
      class="h-5! w-5! shrink-0"
      [class]="iconClass()"></mat-icon>
    <h3 class="text-sm font-semibold text-gray-900">{{ title() }}</h3>
  </div>

  <div class="mt-3 flex-1">
    @if (loading()) {
      <div class="flex flex-col gap-y-2">
        @for (row of skeletonRows; track row) {
          <icaredx-skeleton height="0.875rem" />
        }
      </div>
    } @else if (failed()) {
      <div class="flex flex-col items-start gap-y-2">
        <p class="text-sm text-gray-700">Could not load this section</p>

        <button
          type="button"
          class="text-sm font-medium text-primary-700 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-700"
          (click)="retried.emit()">
          Retry
        </button>
      </div>
    } @else if (isEmpty()) {
      <p class="text-sm text-gray-500">{{ emptyText() }}</p>
    } @else {
      <ng-content />
    }
  </div>

  @if (showViewAll() && !loading() && !failed()) {
    <button
      type="button"
      class="mt-3 flex items-center gap-x-1 self-start text-sm font-medium text-primary-700 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-700"
      (click)="viewAll.emit()">
      View all
      <mat-icon svgIcon="chevron-right" class="h-5! w-5!"></mat-icon>
    </button>
  }
</section>
